import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../helpers/reducerRegistry'
import { handleSelectCheckBox } from '../filterSetting/helper'
import { getFilteredCompaniesBusinessSize } from './thunk'

const initialState = {
  dataByTypeMoney: [],
  listSelectedBusinessSize: [],
  loading: {
    businessSize: true,
  },
}

const slice = createSlice({
  name: 'common/filterCompany/businessSize',
  initialState,
  reducers: {
    resetStoreBusinessSize: () => initialState,
    changeListSelectedListBusinessSize: (state, action) => {
      state.listSelectedBusinessSize = handleSelectCheckBox(
        state.listSelectedBusinessSize,
        action.payload,
      )
    },
    resetBusinessSize: (state) => {
      state.listSelectedBusinessSize = []
    },
  },
  extraReducers: (builder) => {
    //
    builder.addCase(getFilteredCompaniesBusinessSize.pending, (state) => {
      state.loading.businessSize = true
    })
    builder.addCase(
      getFilteredCompaniesBusinessSize.fulfilled,
      (state, action) => {
        state.loading.businessSize = false
        state.dataByTypeMoney = action.payload.map((item) => ({
          label: item.analysisIndicatorTypeName,
          value: item.analysisIndicatorTypeId,
        }))
      },
    )
    builder.addCase(
      getFilteredCompaniesBusinessSize.rejected,
      (state, action) => {
        state.loading.businessSize = action.payload.loading
      },
    )
  },
})

export const loadingSize = (state) => state[slice.name].loading.businessSize

export const selectListSelectedBusinessSize = (state) =>
  state[slice.name].listSelectedBusinessSize

export const selectDataByTypeMoney = (state) =>
  state[slice.name].dataByTypeMoney

export const {
  resetStoreBusinessSize,
  changeListSelectedListBusinessSize,
  resetBusinessSize,
} = slice.actions

register(slice.name, slice.reducer)
